<template>
    <section>
        <div class='mock'>
            <div class='main'>
                loading...
            </div>
        </div>
    </section>
</template>   
<script>
export default {
  name: "loading"
};
</script> 
<style lang="stylus">
section{
  width:100vw;
  height:100vh;
  position:absolute;
  top: 0;
  left: 0;
}
.mock{
  display: flex;
  justify-content: center;
  align-items: center;
  width:100vw;
  height:100vh;
  position:absolute;
  z-index:100;
  background: rgba(0,0,0,0.1);
}
.main{

  // margin:200px auto;
  // text-align:center;
}
</style>